import React, { useEffect, useState } from "react";
import Content from "../layout/content/Content";
import Head from "../layout/head/Head";
import {
  Block,
  BlockDes,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Row,
  Col,
  PreviewAltCard,
  Icon,
} from "../components/Component";
import { useSelector } from "react-redux";
import { ReactTyped } from "react-typed";
import { useNavigate } from "react-router";
import { Flex, Spin } from "antd";

const Modules = [
  {
    key: 1,
    title: "BOQ",
    description:
      "Define and manage Bill of Quantities for every project, forming the foundation for planning and procurement.",
    paths: ["consumption-target-list", "create-consumption-target"],
  },
  {
    key: 2,
    title: "Budget",
    description:
      "Plan, allocate, and track budgets across projects and departments to ensure financial control.",
    paths: ["analytics-budget", "view-budget"],
  },
  {
    key: 3,
    title: "Purchase Request",
    description:
      "Raise and manage material or service requests from sites with real-time approval workflows.",
    paths: ["view-purchase-requests", "track-list", "add-new-purchase-request"],
  },
  {
    key: 4,
    title: "Quotations",
    description:
      "Request, receive, and compare supplier quotations to select the best value offers with evaluation workflows.",
    paths: ["analytics-rfq", "view-rfqs", "qc-list"],
  },
  {
    key: 5,
    title: "Purchase Order",
    description:
      "Create and manage purchase orders linked to quotes, budgets, and project timelines for seamless procurement.",
    paths: ["view-purchase-order", "purchase-order-new"],
  },
  {
    key: 6,
    title: "Invoice",
    description:
      "Handle supplier invoicing with validation, approvals, and real-time status tracking integrated with POs and GRNs.",
    paths: ["view-invoice-list"],
  },
  {
    key: 7,
    title: "Payments",
    description:
      "Track and process payments with complete visibility into dues, approvals, and financial reconciliation.",
    paths: ["payment-analytics", "invoice-payables", "view-payments"],
  },
  {
    key: 8,
    title: "Stock",
    description:
      "Monitor inventory levels across sites with issue tracking, returns, damages, and real-time material availability.",
    paths: ["stock-availability"],
  },
  {
    key: 9,
    title: "Reports",
    description:
      "Get actionable insights through comprehensive reports on procurement, inventory, budgets, and project spend.",
    paths: [
      "view-purchase-reports",
      "view-accounts-payable-reports",
      "view-inventory-reports",
      "view-budget-reports",
      "view-material-management-reports",
    ],
  },
];

const DefaultDashboardPage = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const { data: allowedRoutes } = useSelector((state) => state.allowedRoutes);

  useEffect(() => {
    if (!allowedRoutes || !allowedRoutes.length) return;
    if (allowedRoutes.includes("dashboard")) {
      navigate("/dashboard");
    } else setIsLoading(false);
  }, [allowedRoutes]);

  if (isLoading)
    return (
      <Flex align="center" gap="middle" className="pageLoader">
        <Spin size="large" className="m-auto" />
      </Flex>
    );

  return (
    <React.Fragment>
      <Head title="Procurex Dashboard" />
      <Content>
        <Block>
          <Row className="g-gs">
            {Modules?.map((module) => {
              const { key, title, description, paths } = module;

              const allowedPath = paths.find((route) =>
                allowedRoutes.includes(route)
              );

              if (!allowedPath) {
                return null;
              }
              return (
                <Col md="4">
                  <PreviewAltCard className="">
                    <div className="card-amount">
                      <span className="amount">{title}</span>
                    </div>
                    <div className="title">
                      {description}
                      <br />
                      <br />
                      <button
                        className="btn btn-primary btn-sm"
                        onClick={() => navigate(`/${allowedPath}`)}
                      >
                        Click here &nbsp;{" "}
                        <span>
                          <Icon name="arrow-right" />
                        </span>
                      </button>
                    </div>
                  </PreviewAltCard>
                </Col>
              );
            })}
          </Row>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default DefaultDashboardPage;
